import { render, staticRenderFns } from "./LibraryModal.vue?vue&type=template&id=3c0e7740&scoped=true"
import script from "./LibraryModal.vue?vue&type=script&lang=js"
export * from "./LibraryModal.vue?vue&type=script&lang=js"
import style0 from "./LibraryModal.vue?vue&type=style&index=0&id=3c0e7740&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0e7740",
  null
  
)

export default component.exports